<template>
  <b-container fluid>
    <b-row>
      <b-col md="3">
        <b-form-group
          id="fieldset-1"
          label="Выберите сервер"
        >
          <b-form-select v-model="portalId"
                         :options="portals"
                         value-field="alias"
                         text-field="name"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="4" lg="3">
        <b-form-group
          id="fieldset-2"
          label="Поиск по дате"
        >
          <ctk-date-time-picker
            v-model="date"
            id="DateTimePickerPackages"
            label="Дата с ... дата по ..."
            color="#40b539"
            locale="ru"
            range
            :custom-shortcuts="customShortcuts"
            format="YYYY-MM-DD HH:mm"
            formatted="ll"
          >
          </ctk-date-time-picker>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          id="fieldset-2"
          label="По дате модификации"
        >
          <b-form-checkbox v-model="modified"
          ></b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col class="d-flex align-items-center">
        <b-button variant="success" :disabled="!portalId" @click="loadPackages" class="mt-3">Поиск</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <b-form-group
          label="Поиск по номеру пакета"
        >
          <b-input-group class="search">
            <b-form-input
              v-model="searchPackage"
              type="search"
              id="filterInput"
              placeholder="Введите № пакета"
            ></b-form-input>
            <div class="container_search_close"
                 @click="searchPackage = ''">
              <span class="search-close">&#215;</span>
            </div>
            <b-input-group-append>
              <b-button :disabled="disableButton" @click="loadDefinitePackage" variant="success">Поиск
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <b-form-group>
          <b-form-input v-model="filter" placeholder="Поиск по таблице"/>
          <div class="container_search_close"
               @click="filter = ''">
            <span class="search-close">&#215;</span>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      hover
      show-empty
      responsive
      id="data_table"
      :fields="fields"
      :items="items"
      :busy="visible"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      @filtered="onFiltered"
      @row-hovered="rowHowered"
      @row-unhovered="rowUnhowered"
      class="mt-3 blue technical-support"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу"
    >
      //package
      <template v-slot:cell(package)="data">
        <b><p class="mb-0">{{ data.item.id }}<span
          v-if="data.item.id !== data.item.parent_id">/{{ data.item.parent_id }}</span></p></b>
        <b-badge :variant="convertToStatusColor(data.item.status)">{{ convertStatus(data.item.status) }}</b-badge>
      </template>

      //waybill
      <template v-slot:cell(waybill)="data">
        <ul v-if="data.item.info[101] && data.item.info[101].length > 10" class="mb-0 pl-4">
          <li v-for="(item, index) in data.item.info[101]" :key="item">
            <span v-if="(index < (data.item.info[101].length - 1)) && (index < 10) && (data.item.info[101].length - 1 > 10)">{{ item }}, </span>
            <span v-else-if="index === 10">{{ item }}...</span>
          </li>
        </ul>
        <ul v-else class="mb-0 pl-4">
          <li v-for="(item, index) in data.item.info[101]" :key="item">
            <span v-if="(index < (data.item.info[101].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </li>
        </ul>
      </template>

      //goods number
      <template v-slot:cell(goods_number)="data">
        <p v-if="data.item.info[106]" class="mb-0">{{ data.item.info[106][0] }}</p>
      </template>

      //vehicle
      <template v-slot:cell(vehicle)="data">
        <ul v-if="data.item.info[104] && data.item.info[104].length > 10" class="mb-0 pl-4">
          <li v-for="(item, index) in data.item.info[104]" :key="item">
            <span v-if="(index < (data.item.info[104].length - 1)) && (index < 10) && (data.item.info[101].length - 1 > 10)">{{ item }}, </span>
            <span v-else-if="index === 10">{{ item }}...</span>
          </li>
        </ul>
        <ul v-else class="mb-0 pl-4">
          <li v-for="(item, index) in data.item.info[104]" :key="item">
            <span v-if="(index < (data.item.info[104].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </li>
        </ul>
      </template>

      //place_of_delivery
      <template v-slot:cell(place_of_delivery)="data">
        <p v-if="data.item.info[108]" class="mb-0">{{ data.item.info[108][0] }}</p>
      </template>

      //organization
      <template v-slot:cell(organization)="data">
        <ul v-if="data.item.info[103] && data.item.info[103].length > 5" class="mb-0 pl-4">
          <li v-for="(item, index) in data.item.info[103]" :key="item">
            <span v-if="(index < (data.item.info[103].length - 1)) && (index < 5) && (data.item.info[101].length - 1 > 5)">{{ item }}, </span>
            <span v-else-if="index === 5">{{ item }}...</span>
          </li>
        </ul>
        <ul v-else class="mb-0 pl-4">
          <li v-for="(item, index) in data.item.info[103]" :key="item">
            <span v-if="(index < (data.item.info[103].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </li>
        </ul>
      </template>

      //to
      <template v-slot:cell(to)="data">
        <p class="mb-0">{{ data.item.sender }}</p>
        <b-badge :variant="convertToDirectionColor(data.item.receiver)">{{ convertToDirection(data.item.receiver) }}</b-badge>
      </template>

      //date
      <template v-slot:cell(date)="data">
        <p class="mb-0">{{ (new Date (data.item.create_datetime)).toLocaleString('ru-RU') }}</p>
        <p class="mb-0">{{ (new Date(data.item.modify_datetime)).toLocaleString('ru-RU') }}</p>
      </template>

      // actions
      <template v-slot:cell(actions)="row">
        <actions
          ref="actions"
          :visible="row.item.actions.visible"
          :target="row.item.index"
          @open_documents="openDocuments(row)"
          @show_package_history="showPackageHistory(row.item.id)"
          @show_fts_exchange_history="showFtsExchangeHistory(row.item.id)">
        </actions>
      </template>

      // documents
      <template slot="row-details" slot-scope="row">
        <div v-if="row.item.documents" class="attachments-wrapper">
          <div class="mb-4 no-documents" v-if="row.item.documents.length === 0">Нет документов</div>
          <div v-else v-for="document in row.item.documents"
               @click="openDocument($event, document)"
               class="attachment"
               :key="document.id"
               :style="{ width: attachmentWidth + 'px', position: 'relative' }">
            <div class="attachment-inner-container">
              <div class="file-icon-wrapper">
                <i :class="[{ 'fas fa-file-alt': true }]"></i>
              </div>
              <div class="attachment-name-wrapper">
                <div class="mb-5 mr-4" v-html="document.documentName"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center text-secondary my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Загрузка...</strong>
        </div>
      </template>

      <div slot="table-busy" class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загружаем данные...</strong>
      </div>
    </b-table>
    <b-row>
      <b-col>
        <b-form inline>
          <label class="mr-3">Показать</label>
          <b-form-select :options="pageOptions"
                         v-model="perPage"
                         size="sm"/>
        </b-form>
      </b-col>
      <b-col>
        <b-pagination align="right"
                      prev-text="&lt;"
                      first-text="&lt;&lt;"
                      next-text="&gt;"
                      last-text="&gt;&gt;"
                      size="sm"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage">
        </b-pagination>
      </b-col>
    </b-row>

    <b-modal id="openDocument" class="package-modal text-center" @shown="addHtmlToIframe" @hidden="resetProps" size="xl">
      <template slot="modal-title">
        <div v-html="this.documentName"></div>
      </template>
      <iframe id="showDocument" width="100%" height="400px"></iframe>
      <template slot="modal-footer">
        <b-button @click="printDocument">Распечатать</b-button>
        <b-button @click="downloadDocumentPdf">Скачать в PDF</b-button>
        <b-button v-if="documentXml && (documentXml.length > 0)" @click="downloadDocumentXml">Скачать в XML</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { converterMixin } from './converterMixin'
import CtkDateTimePicker from 'vue-ctk-date-time-picker'
import Actions from './Actions'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'technical-support-packages',
  mixins: [converterMixin],
  components: {
    CtkDateTimePicker,
    Actions
  },
  data () {
    return {
      portalId: null,
      fields: [
        { key: 'package', label: '№ пакета/цепочки' },
        { key: 'waybill', label: '№ накладной' },
        { key: 'organization', label: 'Организации' },
        { key: 'goods_number', label: 'Количество товаров' },
        { key: 'vehicle', label: 'Транспорт' },
        { key: 'place_of_delivery', label: 'Место доставки' },
        { key: 'to', label: 'Отправитель / Направление' },
        { key: 'date', label: 'Дата создания / Дата модификации' },
        { key: 'actions', label: 'Действия', tdClass: 'actions-fixed-width' }
      ],
      items: [],
      date: null,
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ],
      filter: null,
      searchPackage: null,
      disableButton: true,
      modified: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50],
      attachmentWidth: null,
      documentName: null,
      documentHtml: null,
      documentHtmlForPdf: null,
      documentXml: null,
      documentId: null
    }
  },
  watch: {
    packages () {
      this.items = JSON.parse(JSON.stringify(this.packages))
      this.totalRows = this.packages.length
    },
    searchPackage () {
      this.disableButton = !(this.searchPackage !== null && this.portalId !== null)
    }
  },
  mounted () {
    this.getPortalsList()
    this.attachmentWidth = Math.round((window.innerWidth - 16 * 9 - 30) / 7)
    this.attachmentWidth = this.attachmentWidth < 218 ? 218 : this.attachmentWidth
  },
  computed: {
    ...mapState(
      {
        portals: state => state.packages.portals,
        packages: state => state.packages.packages,
        definitePackage: state => state.packages.definitePackage,
        visible: state => state.packages.visible,
        documents: state => state.packages.documents,
        loading: state => state.packages.loading,
        statuses: state => state.packages.statuses
      }
    )
  },
  methods: {
    rowHowered (item, index, event) {
      item.actions.visible = true
    },
    rowUnhowered (item, index, event) {
      item.actions.visible = false
    },
    convertStatus (id) {
      const status = this.statuses.filter((s) => {
        return s.id === id
      })
      return status[0].name
    },
    loadPackages () {
      const params = {
        is_modified: this.modified
      }
      if (this.date !== null) {
        const ISODate = {
          datetime_start: new Date(this.date.start).toISOString(),
          datetime_end: new Date(this.date.end).toISOString()
        }
        Object.assign(params, ISODate)
      }
      if (!this.statuses) {
        this.getStatuses({ portalId: this.portalId }).then(
          () => {
            this.getPackagesFromPortal({ portalId: this.portalId, queryParams: params })
          },
          (error) => {
            console.log(error)
          }
        )
      } else {
        this.getPackagesFromPortal({ portalId: this.portalId, queryParams: params })
      }
    },
    loadDefinitePackage () {
      if (!this.statuses) {
        this.getStatuses({ portalId: this.portalId }).then(
          () => {
            this.getDefinitePackageFromPortal({ portalId: this.portalId, package: this.searchPackage })
          },
          (error) => {
            console.log(error)
          }
        )
      } else {
        this.getDefinitePackageFromPortal({ portalId: this.portalId, package: this.searchPackage })
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openDocuments (row) {
      row.toggleDetails()
      if (row.item.documents === null) {
        this.loadPackageDocuments({ portalId: this.portalId, package: row.item.id }).then(
          () => {
            row.item.documents = this.documents
            this.processDocuments(row)
          },
          error => {
            console.log(error)
          }
        )
      } else {
        row.item.documents = null
      }
    },
    processDocuments (row) {
      let concatDocTitle = ''
      let concatDocName = ''
      let concatDocForwarder = ''
      let concatDocDecisionNumber = ''
      let concatDocCustom = ''
      let concatDocExecutive = ''
      let concatDocDecision = ''
      let concatDocPreparationDate = ''
      let comissionSignature = null
      let decisionSignature = null
      for (let i = 0; i < row.item.documents.length; i++) {
        const docHtml = row.item.documents[i].html
        try {
          let doc = null
          if (window.DOMParser) {
            const parser = new DOMParser()
            doc = parser.parseFromString(docHtml, 'text/html')
          }
          let title = doc.getElementById('documentTitle')
          if (title) title = title.innerHTML
          if (title.length > 0) {
            row.item.documents[i].documentName = title
          }
          if (title && title.indexOf('Решение') === -1) {
            concatDocTitle = title + ' с решением'
            concatDocName = doc.getElementById('NamePersonSignature')
            if (concatDocName) concatDocName = concatDocName.innerHTML
            concatDocForwarder = doc.getElementById('Forwarder')
            if (concatDocForwarder) concatDocForwarder = concatDocForwarder.innerHTML
            concatDocPreparationDate = row.item.documents[i].preparation_date
            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              comissionSignature = {
                info: doc.getElementById('signature-info').innerHTML,
                owner: doc.getElementById('signature-owner').innerHTML,
                issued: doc.getElementById('signature-issued').innerHTML,
                valid: doc.getElementById('signature-valid').innerHTML
              }
            }
            doc.getElementsByClassName('signature')[0].remove()

            doc.getElementsByTagName('style')[0].innerHTML = 'div.pagebook { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; } ' +
              'div.pagelandscape { padding-left: 5mm; padding-right: 5mm; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 7pt; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; font-size: 7pt; } ' +
              // 'table.border tr td { border: 1px solid gray; } ' +
              // '.value { border-bottom: solid 1px black; }' +
              // '.value_b { border: 1px solid gray; } ' +
              'div.title, tr.title td { font-weight: bold; } ' +
              // '.bordered { border-collapse: collapse; } ' +
              'tr td { padding: 1px }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray } ' +

              'tr td.value_b { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value_b:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value_b { border-bottom: 1px solid gray } ' +

              'tr td.value { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value { border-bottom: 1px solid gray } ' +
              'td.graphMain { vertical-align: top; }' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else {
            concatDocDecisionNumber = title
            concatDocCustom = doc.getElementById('customs_department')
            if (concatDocCustom) concatDocCustom = concatDocCustom.innerHTML
            concatDocExecutive = doc.getElementById('executive')
            if (concatDocExecutive) concatDocExecutive = concatDocExecutive.innerHTML
            concatDocDecision = doc.getElementById('decision')
            if (concatDocDecision) concatDocDecision = concatDocDecision.innerHTML
            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              decisionSignature = {
                info: doc.getElementById('signature-info').innerHTML,
                owner: doc.getElementById('signature-owner').innerHTML,
                issued: doc.getElementById('signature-issued').innerHTML,
                valid: doc.getElementById('signature-valid').innerHTML
              }
            }
            row.item.documents[i].htmlAfterProcessing = docHtml
            doc.getElementsByTagName('style')[0].innerHTML = 'div.page { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; padding-bottom: 5mm; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 7pt; } ' +
              '.marg-top { margin-top: 5mm; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; font-size: 7pt; } ' +
              'table.border tr td { border: 1px solid gray; } ' +
              '.graph { font-size: 10pt; } ' +
              '.value { border-bottom: solid 1px black; } ' +
              'div.title, tr.title td { font-weight: bold; } ' +
              '.bordered { border-collapse: collapse; } ' +
              'td.bordered { border: solid 1px windowtext; } ' +
              'td.graphMain { vertical-align: top; } ' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          }
        } catch (e) {
          throw new Error('Ошибка при обработке документа html. ' + (e.message || e))
        }
      }
      this.getMergedDocument(row, concatDocTitle, concatDocName, concatDocForwarder, concatDocDecisionNumber, concatDocCustom, concatDocExecutive, concatDocDecision, concatDocPreparationDate, comissionSignature, decisionSignature)
    },
    getMergedDocument (row, title, name, forwarder, decisionNum, custom, executive, decision, date, comissionSignature, decisionSignature) {
      if (row.item.status === 266) {
        const hasForwarder = forwarder ? '<div>' + forwarder + '</div>' : ''
        const hasName = name ? '<div>Поручение подготовил: ' + name + '</div>' : ''
        const additionalTable = '<table class="bordered w190"><tbody><tr>' +
          '<td style="width: 50%" class="graphMain bordered">' +
          hasForwarder +
          hasName +
          '<div style="white-space: normal;"><b>Поручение подписано электронной подписью</b></div>' +
          '<div style="white-space: normal;">' + comissionSignature.owner + '</div>' +
          '<div style="white-space: normal;">' + comissionSignature.issued + '</div>' +
          '<div style="white-space: normal;">' + comissionSignature.valid + '</div>' +
          '</td>' +
          '<td style="width: 50%" class="graphMain bordered">' +
          '<div><b>' + decisionNum + '</b></div>' +
          '<div>Порт погрузки: ' + custom + '</div>' +
          '<div>Решение: ' + decision + '</div>' +
          '<div>' + date + '</div>' +
          '<div>' + executive + '</div>' +
          '<div style="white-space: normal;"><b>Решение по поручению подписано усиленной квалифицированной электронной подписью</b></div>' +
          '<div style="white-space: normal;">' + decisionSignature.owner + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.issued + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.valid + '</div>' +
          '</td></tr></tbody></table>'
        try {
          let docForView = null
          let docForPdf = null
          if (window.DOMParser) {
            const parserForView = new DOMParser()
            const parserForPdf = new DOMParser()
            docForView = parserForView.parseFromString(row.item.documents[0].htmlAfterProcessing, 'text/html')
            docForPdf = parserForPdf.parseFromString(row.item.documents[0].htmlForPdf, 'text/html')
            const elem1 = document.createElement('div')
            elem1.setAttribute('class', 'pagebook')
            const elem2 = document.createElement('div')
            elem2.setAttribute('class', 'pagebook')
            docForView.getElementsByTagName('body')[0].append(elem1)
            docForView.getElementsByClassName('pagebook')[1].innerHTML = additionalTable
            docForPdf.getElementsByTagName('body')[0].append(elem2)
            docForPdf.getElementsByClassName('pagebook')[1].innerHTML = additionalTable
            row.item.documents[row.item.documents.length] = {
              documentName: title,
              htmlForPdf: docForPdf.getElementsByTagName('html')[0].outerHTML,
              htmlAfterProcessing: docForView.getElementsByTagName('html')[0].outerHTML
            }
          }
        } catch (e) {
          throw new Error('Ошибка при обработке документа html. ' + (e.message || e))
        }
      }
    },
    openDocument (event, document) {
      this.documentHtml = document.htmlAfterProcessing
      this.documentXml = document.xml
      this.documentId = document.package_id
      this.documentName = document.documentName.replace('<br>', ' ')
      this.documentHtmlForPdf = document.htmlForPdf
      event.stopPropagation()
      this.$root.$emit('bv::show::modal', 'openDocument', event)
    },
    addHtmlToIframe () {
      document.getElementById('showDocument').contentWindow.document.open()
      document.getElementById('showDocument').contentWindow.document.write(this.documentHtml)
      document.getElementById('showDocument').contentWindow.document.close()
    },
    resetProps () {
      this.documentHtml = null
      this.documentName = null
      this.documentXml = null
      this.documentId = null
      this.documentHtmlForPdf = null
    },
    printDocument () {
      document.getElementById('showDocument').contentWindow.print()
    },
    downloadDocumentPdf () {
      let temp = document.createElement('div')
      temp.innerHTML = this.documentHtmlForPdf
      document.getElementById('content').appendChild(temp)
      temp.setAttribute('id', 'download-pdf')
      temp.setAttribute('style', 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; display: none')
      const opt = {
        margin: 0,
        filename: this.documentName + '.pdf',
        image: { type: 'jpeg', quality: 0.96 },
        html2canvas: { scale: 4, width: 794, scrollY: 0, scrollX: 0 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }

      setTimeout(() => {
        import('../../node_modules/html2pdf.js/dist/html2pdf.js').then(html2pdf => {
          html2pdf.default().set(opt).from(document.getElementById('download-pdf').innerHTML).save().then(() => {
            const pdf = document.getElementById('download-pdf')
            pdf.parentNode.removeChild(pdf)
            const style = document.getElementById('content').getElementsByTagName('style')
            for (let i = 0; i < style.length; i++) {
              style[i].parentNode.removeChild(style[i])
            }
            temp = null
          })
        })
      }, 600)
    },
    downloadDocumentXml () {
      const filename = this.documentId + '.xml'
      const dHref = document.createElement('a')
      const dBlob = new Blob([this.documentXml], { type: 'text/plain' })
      dHref.setAttribute('href', window.URL.createObjectURL(dBlob))
      dHref.setAttribute('download', filename)
      dHref.dataset.downloadurl = ['text/plain', dHref.download, dHref.href].join(':')
      dHref.click()
    },
    ...mapActions('packages',
      [
        'getPortalsList',
        'getPackagesFromPortal',
        'getDefinitePackageFromPortal',
        'loadPackageDocuments',
        'getStatuses'
      ]
    )
  }
}
</script>

<style scoped lang="scss">
  .search {
    position: relative;
    .container_search_close {
      right: 75px;
    }
  }
  .container_search_close {
    position: absolute;
    right: 20px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
      span {
        color: #fff;
      }
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 18px;
      text-align: center;
      margin-bottom: 2px;
    }
  }
  .attachments-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    .attachment {
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 10px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
      position: relative;
      &:hover {
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
        cursor: pointer;
      }
      .attachment-inner-container {
        display: flex;
        width: 100%;
        word-break: break-all;
        .file-icon-wrapper {
          margin-right: 10px;
          i {
            font-size: 32px;
            color: #78909C;
            min-height: 80px;
          }
        }
        .attachment-name-wrapper {
          font-size: 14px;
          letter-spacing: 0.25px;
          line-height: 20px;
          color: #37474F;
        }
      }
    }
  }
  .no-documents {
    width: 100%;
    text-align: center;
  }
</style>
